import { defineComponent as V, useAttrs as N, inject as S, computed as l, openBlock as d, createElementBlock as i, normalizeClass as g, unref as C, withDirectives as h, createElementVNode as B, mergeProps as R, vModelRadio as _, renderSlot as A, createTextVNode as k, toDisplayString as z, createCommentVNode as D } from "vue";
import { RadioSize as E, RadioSymbol as M, getRadioStyleClasses as $ } from "./novoui-vuejs59.js";
const j = ["name", "value", "disabled"], w = {
  key: 0,
  class: "radio-label"
}, q = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "NRadio",
  props: {
    size: { default: E.medium },
    value: { type: [String, Number, Boolean], default: void 0 },
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    label: {},
    disabled: { type: Boolean },
    error: { type: Boolean }
  },
  emits: [
    /*
     * Emitted when the radio is clicked.
     */
    "update:modelValue"
  ],
  setup(r, { emit: u }) {
    const { class: m, ...o } = N(), e = r, c = u, t = S(M, {}), p = l(() => o.name !== void 0 ? o.name : t.name), b = l(() => t.disabled || e.disabled), f = l(() => typeof e.value > "u" ? e.label : e.value), s = l({
      get: () => e.modelValue ?? t.selected,
      set: (a) => {
        e.modelValue !== void 0 && c("update:modelValue", a), t.onChange && (t == null || t.onChange(a));
      }
    }), v = l(() => $(e, t));
    return (a, n) => (d(), i("label", {
      class: g([v.value, C(m)])
    }, [
      h(B("input", R({
        type: "radio",
        class: "radio-input",
        name: p.value,
        value: f.value,
        "onUpdate:modelValue": n[0] || (n[0] = (y) => s.value = y),
        disabled: b.value
      }, o), null, 16, j), [
        [_, s.value]
      ]),
      e.label || a.$slots.default ? (d(), i("span", w, [
        A(a.$slots, "default", {}, () => [
          k(z(a.label), 1)
        ])
      ])) : D("", !0)
    ], 2));
  }
});
export {
  q as default
};
